export default __webpack_public_path__ + "a5b9612080c5937e5655c37ed0ea3a2e.png";